import { Header } from "./-components/header"
import { useEffect } from "react"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(site)/cookies")({
  component: CookiePolicy,
})

function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 max-w-4xl">
        <article className="prose prose-slate dark:prose-invert max-w-none">
          <h1>Cookie Policy for Knowledge Facts Ladder (KFL)</h1>
          <p className="text-muted-foreground">Last updated: 03.12.2025</p>

          <p>
            This Cookie Policy explains how Knowledge Facts Ladder ("KFL", "we",
            "our", "us") uses cookies and similar technologies on our website.
            By using the KFL website, you agree to the use of cookies as
            described in this Policy.
          </p>

          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a
            website. They help websites function properly, remember your
            preferences, and improve your browsing experience.
          </p>
          <p>
            Cookies do not give us access to your computer or personal files.
          </p>

          <h2>2. Types of Cookies We Use</h2>
          <p>KFL may use the following categories of cookies:</p>

          <h3>2.1. Essential Cookies</h3>
          <p>
            These cookies are necessary for the website to function. They enable
            features such as:
          </p>
          <ul>
            <li>account login</li>
            <li>session management</li>
            <li>quiz access</li>
            <li>security and fraud prevention</li>
          </ul>
          <p>
            You cannot disable essential cookies because the website would not
            function correctly without them.
          </p>

          <h3>2.2. Performance and Analytics Cookies (optional)</h3>
          <p>
            If used, these cookies help us understand how users interact with
            the site, including:
          </p>
          <ul>
            <li>pages visited</li>
            <li>time spent on pages</li>
            <li>actions taken</li>
            <li>technical performance</li>
          </ul>
          <p>
            Analytics tools (e.g., Google Analytics) may set these cookies. They
            help us improve content, structure, and user experience.
          </p>
          <p>
            If we implement analytics, users will be notified and given a choice
            to consent.
          </p>

          <h3>2.3. Functional Cookies</h3>
          <p>
            These cookies allow the website to remember choices you make, such
            as:
          </p>
          <ul>
            <li>preferred language</li>
            <li>display settings</li>
            <li>saved preferences</li>
          </ul>
          <p>They enhance convenience but are not strictly necessary.</p>

          <h3>2.4. Third-Party Cookies (limited use)</h3>
          <p>KFL may use third-party services for:</p>
          <ul>
            <li>hosting videos (e.g., YouTube embeds)</li>
            <li>processing payments (e.g., PayPal, Wise, Payoneer)</li>
            <li>email delivery or security tools</li>
          </ul>
          <p>
            These third parties may set their own cookies. We do not control
            their cookie policies, and you should check their individual
            notices.
          </p>
          <p>KFL does not use third-party advertising cookies.</p>

          <h2>3. How We Use Cookies</h2>
          <p>We use cookies to:</p>
          <ul>
            <li>maintain secure login sessions</li>
            <li>ensure quizzes load and function correctly</li>
            <li>prevent fraud or abuse</li>
            <li>measure website performance</li>
            <li>improve navigation and usability</li>
            <li>remember user preferences</li>
            <li>
              support anti-cheating detection mechanisms (where applicable)
            </li>
          </ul>
          <p>
            We do not use cookies to sell personal data, track external
            browsing, or serve targeted ads.
          </p>

          <h2>4. Managing Your Cookie Preferences</h2>
          <p>
            You can manage or delete cookies at any time using your browser
            settings. Most browsers allow you to:
          </p>
          <ul>
            <li>block cookies</li>
            <li>delete existing cookies</li>
            <li>receive alerts before cookies are stored</li>
            <li>restrict third-party cookies</li>
          </ul>
          <p>Instructions for common browsers:</p>
          <ul>
            <li>
              <strong>Chrome:</strong> Settings → Privacy and Security → Cookies
            </li>
            <li>
              <strong>Firefox:</strong> Options → Privacy & Security → Cookies
              and Site Data
            </li>
            <li>
              <strong>Safari:</strong> Preferences → Privacy
            </li>
            <li>
              <strong>Edge:</strong> Settings → Site Permissions → Cookies
            </li>
          </ul>
          <p>
            If you disable essential cookies, parts of the KFL website may not
            function properly.
          </p>

          <h2>5. Changes to This Cookie Policy</h2>
          <p>
            We may update this Cookie Policy to reflect changes in technology,
            website functionality, or legal requirements. When changes are made,
            we will update the date at the top of this page.
          </p>
          <p>
            Continued use of the website indicates acceptance of the updated
            Cookie Policy.
          </p>

          <h2>6. Contact Us</h2>
          <p>
            If you have questions or requests regarding this Cookie Policy,
            contact:
          </p>
          <p>
            <a href="mailto:knowledge.facts.ladder@gmail.com">
              knowledge.facts.ladder@gmail.com
            </a>
            <br />
            <a href="https://www.kflquiz.com">www.kflquiz.com</a>
          </p>
        </article>
      </main>
    </div>
  )
}
